// The candidate's CV, loaded inline inside the profile card. Embeds the resume
// with the shared ATS PDF viewer (PDFReaderBrowser — the same one the candidate
// Resume page uses) so the document renders in place rather than as a
// filename + Preview/Download row.

import { Box, Flex } from '@chakra-ui/react';
import { PDFReaderBrowser } from '@/components/file-viewers/reactPdf';
import type { ResumeSectionProps } from './ResumeSection.types';

// Height of the inline viewer inside the profile panel.
const VIEWER_HEIGHT = 460;

export const ResumeSection = ({ resumes }: ResumeSectionProps) => {
  const withUrl = resumes.filter((r) => r.url);
  if (withUrl.length === 0) return null;

  return (
    <Flex
      direction="column"
      gap="12px"
      data-test-id="agentforge-resume-section"
    >
      {withUrl.map((r) => (
        <Box
          key={r.id}
          height={`${VIEWER_HEIGHT}px`}
          border="1px solid"
          borderColor="border-color"
          borderRadius="8px"
          overflow="hidden"
        >
          <PDFReaderBrowser
            file={r.url}
            content_type={r.contentType}
            preview_url=""
            fileName={r.fileName}
            isCompact
          />
        </Box>
      ))}
    </Flex>
  );
};
